import { mode } from '@chakra-ui/theme-tools';
const Card = {
  baseStyle: (props) => ({
    p: '24px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
    borderRadius: '1rem',
    minWidth: '0px',
    wordWrap: 'break-word',
    bg: mode('#ffffff', 'gray.950')(props),
    border: mode('none', '1px solid')(props),
    borderColor: mode('transparent', 'gray.800')(props),
    boxShadow: mode(
      '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
      'unset',
    )(props),
    backgroundClip: 'border-box',
  }),
};

export const CardComponent = {
  components: {
    Card,
  },
};
